import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Modal from '../../modals/Modal';
import Button from '../../shared/Button';
import Autocomplete from '../../shared/Autocomplete';

import { sortAlphabetically } from '../../../util/utils';
import Typography from '@mui/material/Typography';

const CaseRequestDateHospitalModal = (props) => {
  const {
    open,
    onClose,
    selectedCase,
    onSubmit,
    loading,
    hospitals = [],
    surgeons = [],
  } = props;

  const [date, setDate] = useState(moment());
  const [hospital, setHospital] = useState(null);

  useEffect(() => {
    if (open && selectedCase?.hospital) {
      const currentHospital = hospitals?.find(
        (h) => h.id === selectedCase?.hospitalUniq?.id
      );
      if (currentHospital) {
        setHospital(currentHospital);
      }
    }
  }, [open, hospitals, selectedCase]);

  const list = useMemo(() => {
    const surgeon = surgeons?.find((s) => s.id === selectedCase?.surgeonId);
    return hospitals?.filter((h) => surgeon?.hospitals?.includes(h.id));
  }, [hospitals, surgeons, selectedCase]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Request Surgery Date"
      subtitle={selectedCase?.formattedId || selectedCase?.id}
      onSubmit={() => onSubmit(date, hospital)}
      size="md"
      disabled={loading}
      loading={loading}
      autoSize
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div className="d-flex direction-column space-between">
          <Box>
            <div className="p-lg font-bold" style={{ maxWidth: 400 }}>
              Please request a surgery date and update the hospital if required
              for review and approval by an admin
            </div>
          </Box>

          <div className="p-lg width-100">
            <Typography sx={{ fontSize: 14 }}>Requested Surgery Date</Typography>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={date}
              onChange={(newDate) => setDate(newDate)}
              minDate={moment()}
              slotProps={{
                textField: {
                  variant: 'standard',
                },
              }}
            />
          </div>

          <div className="p-l-lg p-r-lg width-100">
            <Autocomplete
              value={hospital}
              onChange={setHospital}
              options={[...list].sort(sortAlphabetically('name'))}
              getOptionLabel={(option) => option.name}
              label="Hospital"
            />
          </div>
        </div>
      </LocalizationProvider>

      <div className="d-flex w-100 space-between p-lg m-t-lg">
        <div className="secondary pointer" onClick={onClose}>
          Cancel
        </div>
        <Button
          text="Request Date"
          color="primary"
          onClick={() => onSubmit(date, hospital)}
          disabled={loading}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default CaseRequestDateHospitalModal;
